import { c as _c } from "react/compiler-runtime";
import type { VariantProps } from 'class-variance-authority';
import { Button as ButtonPrimitive } from '@base-ui/react/button';
import { cva } from 'class-variance-authority';
import { cn } from 'cn';
export const buttonVariants = cva(['group/button inline-flex shrink-0 items-center justify-center rounded-4xl border border-transparent bg-clip-padding text-sm font-medium whitespace-nowrap transition-all outline-none select-none', 'focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50', 'active:not-aria-[haspopup]:translate-y-px', 'disabled:pointer-events-none disabled:opacity-50', 'aria-invalid:border-destructive aria-invalid:ring-[3px] aria-invalid:ring-destructive/20', 'dark:aria-invalid:border-destructive/50 dark:aria-invalid:ring-destructive/40', "[&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4"], {
  variants: {
    variant: {
      default: 'bg-primary text-primary-foreground hover:bg-primary/80',
      outline: 'border-border bg-input/30 hover:bg-input/50 hover:text-foreground aria-expanded:bg-muted aria-expanded:text-foreground',
      secondary: ['bg-secondary text-secondary-foreground', 'hover:bg-[color-mix(in_oklch,var(--secondary),var(--foreground)_5%)]', 'aria-expanded:bg-secondary aria-expanded:text-secondary-foreground'],
      ghost: 'hover:bg-muted hover:text-foreground aria-expanded:bg-muted aria-expanded:text-foreground dark:hover:bg-muted/50',
      destructive: ['bg-destructive/10 text-destructive', 'hover:bg-destructive/20', 'focus-visible:border-destructive/40 focus-visible:ring-destructive/20', 'dark:bg-destructive/20', 'dark:hover:bg-destructive/30', 'dark:focus-visible:ring-destructive/40'],
      link: 'text-primary underline-offset-4 hover:underline'
    },
    size: {
      default: 'h-9 gap-1.5 px-3 has-data-[icon=inline-end]:pr-2.5 has-data-[icon=inline-start]:pl-2.5',
      xs: ['h-6 gap-1 px-2.5 text-xs', 'has-data-[icon=inline-end]:pr-2', 'has-data-[icon=inline-start]:pl-2', "[&_svg:not([class*='size-'])]:size-3"],
      sm: 'h-8 gap-1 px-3 has-data-[icon=inline-end]:pr-2 has-data-[icon=inline-start]:pl-2',
      lg: 'h-10 gap-1.5 px-4 has-data-[icon=inline-end]:pr-3 has-data-[icon=inline-start]:pl-3',
      icon: 'size-9',
      'icon-xs': "size-6 [&_svg:not([class*='size-'])]:size-3",
      'icon-sm': 'size-8',
      'icon-lg': 'size-10'
    }
  },
  defaultVariants: {
    variant: 'default',
    size: 'default'
  }
});
type ButtonProps = ButtonPrimitive.Props & VariantProps<typeof buttonVariants>;
export function Button(props) {
  const $ = _c(14);
  let children;
  let className;
  let rest;
  let t0;
  let t1;
  if ($[0] !== props) {
    ({
      children,
      className,
      variant: t0,
      size: t1,
      ...rest
    } = props);
    $[0] = props;
    $[1] = children;
    $[2] = className;
    $[3] = rest;
    $[4] = t0;
    $[5] = t1;
  } else {
    children = $[1];
    className = $[2];
    rest = $[3];
    t0 = $[4];
    t1 = $[5];
  }
  const variant = t0 === undefined ? "default" : t0;
  const size = t1 === undefined ? "default" : t1;
  let t2;
  if ($[6] !== className || $[7] !== size || $[8] !== variant) {
    t2 = cn(buttonVariants({
      variant,
      size,
      className
    }));
    $[6] = className;
    $[7] = size;
    $[8] = variant;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== children || $[11] !== rest || $[12] !== t2) {
    t3 = <ButtonPrimitive data-slot="button" className={t2} {...rest}>{children}</ButtonPrimitive>;
    $[10] = children;
    $[11] = rest;
    $[12] = t2;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  return t3;
}